import Tooltip from "components/Tooltip";
import { FormikHelpers } from "formik";
import { FormikInputWithLabel } from "newui/components/ui/InputWithLabel"

interface EmailFieldProps {
	confirmedEmail?: string;
	emailDataTestid: string;
	setFieldValue?: FormikHelpers<any>["setFieldValue"];
}

export const EmailField = ({ confirmedEmail, emailDataTestid, setFieldValue }: EmailFieldProps) => {

	const isEmailConfirmed = !!confirmedEmail;

	return <Tooltip label={isEmailConfirmed ? "Invited email cannot be changed" : ""} shouldWrapChildren={false}>
		<div>
			<FormikInputWithLabel
				id="email"
				label="Email"
				name="email"
				type="email"
				placeholder="Enter your email"
				className="col xl-12"
				data-testid={emailDataTestid}
				setFieldValue={setFieldValue}
				autoComplete="username"
				aria-required="true"
				maxLength={190}
				required
				disabled={isEmailConfirmed}
			/>
		</div>
	</Tooltip>
}